import React from "react";

import {
  List,
  DataTable,
  TextField,
  TextInput,
  TopToolbar,
  ColumnsButton,
} from "react-admin";

const filters = [<TextInput source="name" label="Name" />];

export const FirmwareList = (props: any) => (
  <List
    {...props}
    pagination={null}
    storeKey={false}
    empty={false}
    filters={filters}
    actions={
      <TopToolbar>
        <ColumnsButton />
      </TopToolbar>
    }
  >
    <DataTable rowClick={false} bulkActionButtons={false}>
      <DataTable.Col source="name" label="Firmware Name" disableSort>
        <TextField source="name" label="Firmware Name" />
      </DataTable.Col>
    </DataTable>
  </List>
);
